import {
    Alert,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography,
} from '@mui/material';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

interface DeleteAccountDialogProps {
    open: boolean;
    isGoogleUser: boolean;
    isLoading: boolean;
    deleteConfirmation: string;
    deletePassword: string;
    onClose: () => void;
    onConfirm: () => void;
    onDeleteConfirmationChange: (value: string) => void;
    onDeletePasswordChange: (value: string) => void;
}

const DeleteAccountDialog: React.FC<DeleteAccountDialogProps> = ({
    open,
    isGoogleUser,
    isLoading,
    deleteConfirmation,
    deletePassword,
    onClose,
    onConfirm,
    onDeleteConfirmationChange,
    onDeletePasswordChange,
}) => {
    const { t } = useTranslation();
    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            BackdropProps={{
                sx: {
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    backdropFilter: 'blur(5px)'
                }
            }}
        >
            <DialogTitle>{t('settings.dialogs.deleteAccount.title')}</DialogTitle>
            <DialogContent>
                <Stack sx={{ 
                    mt: 1, 
                    gap: 2 
                }}>
                    <Alert 
                        severity="warning"
                        sx={{
                            '& .MuiAlert-message': {
                                fontWeight: 'bold'
                            }
                        }}
                    >
                        {t('settings.dialogs.deleteAccount.description')}
                    </Alert>
                    <Typography fontWeight="bold" fontSize="1rem">{t('settings.dialogs.deleteAccount.confirmationText')}</Typography>
                    <TextField
                        fullWidth
                        value={deleteConfirmation}
                        onChange={(e) => onDeleteConfirmationChange(e.target.value)}
                    />
                    {!isGoogleUser && (
                        <TextField
                            type="password"
                            label={t('settings.dialogs.deleteAccount.password')}
                            fullWidth
                            value={deletePassword}
                            onChange={(e) => onDeletePasswordChange(e.target.value)}
                        />
                    )}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('settings.dialogs.deleteAccount.buttons.cancel')}</Button>
                <Button 
                    onClick={onConfirm} 
                    color="error" 
                    disabled={deleteConfirmation !== t('settings.dialogs.deleteAccount.confirmationWord') || isLoading}
                    sx={{ fontWeight: 'bold' }}
                >
                    {isLoading ? <CircularProgress size={24} /> : t('settings.dialogs.deleteAccount.buttons.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteAccountDialog;
